<footer class="layout-footer text-sm text-[var(--text-color-secondary)]">
    {{ productName }} · Powered by
    <a
        href="https://triatechsol.com/"
        target="_blank"
        rel="noopener noreferrer"
        class="font-semibold text-[var(--text-primary)] hover:underline"
        data-testid="footer-powered-by-link"
        >TriA Tech Solution</a
    >
</footer>
